import api from './api';

export type TgChannelStatus = 'prospect' | 'contacted' | 'agreed' | 'posted' | 'skip';
export type TgChannelCategory = 'traffic' | 'bloggers' | 'teams' | 'conferences' | 'partners' | 'jobs' | 'creatives' | 'gossip' | 'seo' | 'misc';

export type TgChannelGrade = 'A+' | 'A' | 'B' | 'C' | 'D' | 'F';

export interface TgChannel {
  id: number;
  category: TgChannelCategory;
  name: string;
  handle: string;
  subscribers: number;
  reach: number;
  price: string | null;
  status: TgChannelStatus;
  comment: string | null;
  contact: string | null;
  fixed_order: number;
  ai_grade: TgChannelGrade | null;
  ai_recommendation: string | null;
  created_at: string;
  updated_at: string;
}

export interface TgChannelListResponse {
  data: TgChannel[];
  current_page: number;
  last_page: number;
  total: number;
}

export interface TgChannelFormData {
  category: string;
  name: string;
  handle: string;
  subscribers?: number;
  reach?: number;
  price?: string | null;
  status?: TgChannelStatus;
  comment?: string | null;
  contact?: string | null;
}

export const listTgChannels = async (params?: {
  page?: number;
  per_page?: number;
  search?: string;
  category?: string;
  status?: string;
  ai_grade?: string;
}): Promise<TgChannelListResponse> => {
  const res = await api.get<TgChannelListResponse>('/api/admin/tg-channels', { params });
  return res.data;
};

export const createTgChannel = async (data: TgChannelFormData): Promise<TgChannel> => {
  const res = await api.post<{ channel: TgChannel }>('/api/admin/tg-channels', data);
  return res.data.channel;
};

export const updateTgChannel = async (id: number, data: Partial<TgChannelFormData>): Promise<TgChannel> => {
  const res = await api.put<{ channel: TgChannel }>(`/api/admin/tg-channels/${id}`, data);
  return res.data.channel;
};

export const deleteTgChannel = async (id: number): Promise<void> => {
  await api.delete(`/api/admin/tg-channels/${id}`);
};

export const bulkUpdateTgChannelStatus = async (ids: number[], status: TgChannelStatus): Promise<void> => {
  await api.put('/api/admin/tg-channels/bulk-status', { ids, status });
};
